(function () {
    'use strict';

    angular
        .module('app')
        .controller('PrototypeEditController', PrototypeEditController);


    function PrototypeEditController($scope, $rootScope, $filter, $timeout,
        $state, $stateParams, $q, ImageUrl, UploadedImageUrl, DefaultThumbnailSize, DefaultEnlargeSize,
        ImageNotAvailableName, FileTypeExtImageUrl, WebAPIUrl, PrototypeService, $location, cfpLoadingBar,
        SearchHelpService, UserService, StatusService, BriefService, PatternService, WorkflowService, ImageService, BrandService,
        SeasonService, toaster, PdmServices, LinePlanService, CarryoverService, SearchFactory, WebApiService, PermissionService) {

        var model = this;

        $scope.prototypeSeasonalId = $stateParams.prototypeSeasonalId;
        $scope.devPrototypeId = $stateParams.devPrototypeId;
        $scope.isFactoryUser = $rootScope.isFactoryUser;
        $scope.userId = $rootScope.userId;
        $scope.brandPermissions = $rootScope.brandPermissions;
        $scope.linkPsid = $stateParams.psid;
        $scope.criticalPathCommercializationId = $stateParams.criticalPathCommercializationId;
        $scope.CanViewFactoryFields = $rootScope.globals.currentUser.isFactoryUser !== true;
        $scope.currentUser = $rootScope.globals.currentUser;
        $scope.fullName = $rootScope.fullName;
        $scope.urlId = $location.search().profile;
        $scope.userPermissions = $rootScope.userPermissions;
        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.goToUserPage = function (data) {
            console.log('data', data)
            $state.go(data.pageName, data.params);
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }

        $scope.stateReload = function () {
            $state.reload();
        }


        model.currentUser = $rootScope.globals.currentUser;
        model.PrototypeRead = "";
        model.PrototypeEdit = "";
        model.PrototypeCreate = "";
        model.PrototypeRRAssignment = "";
        model.PrototypeStatusChange = "";
        model.isReadOnly = "";
        model.statusReadOnly = "";
        model.CanViewCosting = model.currentUser.isFactoryUser !== true;
        model.CanViewFactoryFields = model.currentUser.isFactoryUser !== true;
        model.canShift = false;
        model.canDualSource = model.currentUser.isFactoryUser !== true;
        model.canFactoryTransfer = false;

        $scope.ImageNote = 'ImageNote.html';
        $scope.PrototypeSeasons = 'PrototypeSeasons.html';
        $scope.today = $filter('date')(new Date(), 'yyyy-MM-dd');

        $scope.ffcCurrencySymbol = "$";
        $scope.estFfcCurrencySymbol = "$";
        model.currencies = [];

        model.ImageUrl = ImageUrl;
        model.FileTypeExtImageUrl = FileTypeExtImageUrl;
        model.WebAPIUrl = WebAPIUrl;
        model.image = null;
        model.imageFileName = '';
        model.isSFOverrideAllowed = "";
        model.isBrandPDMReady = "";
        model.IsECN = false;
        model.InitialPrototypeDisabled = false;
        model.SMDisabled = false;
        model.ISRDisabled = false;
        model.LDMDisabled = false;
        model.SMFinalDisabled = false;
        model.CostingCompleteDisabled = true;
        model.OutsoleTechs = [];
        model.shiftSeasonId = 0;
        model.shiftSeasons = [];
        model.shiftLinePlanId = 0;
        model.shiftLinePlan = null;

        //Image droplet properties
        model.validImageExtensions = ['jpg', 'jpeg', 'gif', 'png'];
        model.filesUploaded = 0;
        model.inValidFiles = 0;

        model.failedFiles = "";

        model.imageInterface = {};
        model.patternsForRelink = [];

        // Listen for when the interface has been configured.
        $scope.$on('$dropletReady',
            function whenDropletReady() {
                //Image interface
                model.imageInterface.allowedExtensions(['png', 'jpg', 'bmp', 'gif']);
                model.imageInterface.defineHTTPSuccess([/2.{2}/]);
                model.imageInterface.useArray(true);
            });

        $scope.status = {
            open: true,
            isFirstOpen: true,
            isFirstDisabled: false
        };

        model.getUser = function ($model) {
            if ($scope.prototypeEditForm.$dirty) {
                if (!$model) {
                    var nameCheck = false;
                    $scope.getUserResponse = false;
                    angular.forEach(model.users,
                        function (k) {
                            var name = model.prototypeSeasonalDetails.ResponsibleName.FullName
                                ? model.prototypeSeasonalDetails.ResponsibleName.FullName.toLowerCase()
                                : model.prototypeSeasonalDetails.ResponsibleName.toLowerCase();
                            if (name == k.FullName.toLowerCase() && !nameCheck) {
                                $scope.getUserResponse = true;
                                model.prototypeSeasonalDetails.ResponsibleId = k.Id;
                                model.prototypeSeasonalDetails.ResponsibleName = k.FullName; //assign name
                                nameCheck = true;
                            }
                        })
                } else {
                    $scope.getUserModel = $model;
                    model.prototypeSeasonalDetails.ResponsibleId = $scope.getUserModel.Id;
                    $scope.getUserResponse = true;
                }
                model.validateUser();
            }
        };

        model.validateUser = function () {
            $timeout(function () {
                if ($scope.getUserResponse) {
                    $scope.prototypeEditForm.rrAssignment.$setValidity('responsibleName', true);
                } else {
                    $scope.prototypeEditForm.rrAssignment.$setValidity('responsibleName', false);
                }
            }, 100);
        };

        angular.forEach($rootScope.userPermissions,
            function (userPermissionRow) {
                if (userPermissionRow[0] == 5) {
                    if (userPermissionRow[1] == 1) {
                        model.PrototypeRead = true;
                    }
                    if (userPermissionRow[1] == 2) {
                        model.PrototypeEdit = true;
                        $scope.editMode = true;
                    }
                    if (userPermissionRow[1] == 3) {
                        model.PrototypeCreate = true;
                    }
                    if (userPermissionRow[1] == 4) {
                        model.PrototypeStatusChange = true;
                    }
                    if (userPermissionRow[1] == 5) {
                        model.PrototypeRRAssignment = true;
                    }
                    if (userPermissionRow[1] == 7) {
                        model.PrototypeDelete = true;
                    }
                }

                //ECN Permissions
                if (userPermissionRow[0] == 8) {
                    model.UserHasECNPermission = true;
                }
            });

        model.canReadQuarterlyForecasting = PermissionService.canReadQuarterlyForecasting();

        if (!model.PrototypeRead && !model.PrototypeEdit) {
            $state.go('permissionDenied');
        }

        model.prototypeSeasonalId = $stateParams.prototypeSeasonalId;

        //StatusService.isRecordDeleted(4, model.prototypeSeasonalId)
        //    .then(function (response) {
        //        if (response == true) {
        //            toaster.pop({
        //                type: 'note',
        //                title: 'Colorway Deleted',
        //                body: 'The Colorway you are trying to access is deleted.',
        //                timeout: 5000
        //            });
        //            $state.go('Search');
        //        }
        //    },
        //        function (error, status) {
        //            toaster.pop({
        //                type: 'error',
        //                title: 'Error',
        //                body: 'Please contact your System Administrator.',
        //                timeout: 5000
        //            });
        //            $state.go('Search');
        //        });

        function getBrandPermissions(brandId) {
            //brand permissions
            if (!$rootScope.brandPermissions)
                return;
            var idx = $rootScope.brandPermissions.map(function (e) { return e.BrandId }).indexOf(brandId);
            if (!$rootScope.brandPermissions[idx].IsAssigned) {
                $state.go('permissionDenied');
                return;
            }
        }

        function getUsers() {
            UserService.getUsersByBrand(model.prototypeDetails.BrandId).then(function (data) {
                model.users = data;
            });
        }

        function getWFGroups() {
            WorkflowService.getWFGroups(model.prototypeDetails.BrandId, 4).then(function (data) {
                model.groupList = data;
            });
        }

        function getStatusList(currentStatusId) {
            StatusService.getAvailableStatusList(currentStatusId).then(function (data) {
                model.statusList = data;
            });
        }

        function getLaunchList() {
            PrototypeService.getLaunchList(model.prototypeSeasonalId).then(function (data) {
                model.launchList = data;
            });
        }

        function getAgeCodeList() {
            PrototypeService.getAgeCodeList().then(function (data) {
                model.ageCodeList = data;
            });
        }

        function getECNReasons() {
            PrototypeService.getECNReasons().then(function (data) {
                model.ECNReasons = data;
            });
        }

        function getProductLineList() {
            PatternService.getProductLineList().then(function (data) {
                model.productLineList = data;
            });
        }

        function getWidthList() {
            PrototypeService.getWidthList().then(function (data) {
                model.widthList = data;
            });
        }

        function getProductTypeList(patternDevTypeId) {
            PrototypeService.getProductTypeList(patternDevTypeId).then(function (data) {
                model.productTypeList = data;
            });
        }

        function isSFOverrideallowed() {
            BrandService.canSfOverride(model.prototypeDetails.BrandId).then(function (response) {
                model.isSFOverrideAllowed = response;
            });
        }

        function isBrandPDMReady() {
            BrandService.isBrandPDMReady(model.prototypeDetails.BrandId).then(function (response) {
                model.isBrandPDMReady = response;
            });
        }

        function getOutsoleTechs() {
            PrototypeService.GetOutsoleTechs().then(function (techs) {
                model.OutsoleTechs = techs;
            });
        }

        function getCurrencies() {
            SearchHelpService.searchCurrencies().then(function (currencies) {
                model.currencies = currencies;

                $scope.setCurrencySymbols();
            });
        }

        $scope.setCurrencySymbols = function () {
            angular.forEach(model.currencies, function (currency) {
                if (currency.CurrencyKey === model.prototypeSeasonalDetails.FfcCurr) {
                    $scope.ffcCurrencySymbol = $filter("currencySymbol")(currency);
                }
                if (currency.CurrencyKey === model.prototypeSeasonalDetails.EstFfcCurr) {
                    $scope.estFfcCurrencySymbol = $filter("currencySymbol")(currency);
                }
            });
        };

        //NOTE: Much of this milestone logic is duplicated in flashEditCosting.ctrl.js. If changes are made here, they probably need to be made there also.
        model.milestoneChecked = function (completeProp) {
            var deferred = $q.defer();
            var checked = model.prototypeSeasonalDetails[completeProp] === true;
            if (checked) {
                if (model.isBrandPDMReady) {
                    PdmServices.calcPdmPrice(model.prototypeDetails.PrototypeId, model.prototypeSeasonalDetails.SeasonId).then(function (response) {
                        var success = model.trySetMilestoneValues(completeProp, true, response);
                        deferred.resolve(success);
                    });
                } else {
                    var success = model.trySetMilestoneValues(completeProp, true, model.prototypeSeasonalDetails.FFC);
                    deferred.resolve(success);
                }
            } else {
                model.trySetMilestoneValues(completeProp, false, null);
                deferred.resolve(false);
            }
            return deferred.promise;
        };

        model.trySetMilestoneValues = function (completeProp, checked, price) {
            if (!model.canCheckMilestone(checked, price)) {
                toaster.pop({
                    type: "Alert",
                    title: "Alert!",
                    body: "Factory First Cost must be entered before you can check off a milestone!",
                    timeout: 5000
                });
                return false;
            }

            var dateProp = model.milestoneFieldMap[completeProp][0];
            var priceProp = model.milestoneFieldMap[completeProp][1];

            if (price) {
                model.prototypeSeasonalDetails.FFC = price;
                model.prototypeSeasonalDetails[priceProp] = price;
                model.prototypeSeasonalDetails[dateProp] = $scope.today;
            } else {
                model.prototypeSeasonalDetails[priceProp] = null;
                model.prototypeSeasonalDetails[dateProp] = null;
            }

            return true;
        }

        model.canCheckMilestone = function (checked, price) {
            if (checked && (!price || price <= 0)) {
                return false;
            }
            return true;
        }

        model.initialPrototypeChecked = function () {
            model.milestoneChecked("InitialPrototypeComplete")
                .then(function (checked) {
                    if (checked) {
                        model.setMilestoneAccess();
                    }
                    else {
                        model.prototypeSeasonalDetails.InitialPrototypeComplete = false;
                    }
                });
        };

        model.isrChecked = function () {
            model.milestoneChecked("ISRComplete")
                .then(function (checked) {
                    if (checked) {
                        if (model.prototypeSeasonalDetails.ISRComplete === true && model.prototypeSeasonalDetails.InitialPrototypeComplete !== true) {
                            model.prototypeSeasonalDetails.InitialPrototypeComplete = true;
                            model.initialPrototypeChecked();
                            return;
                        }
                    }
                    else {
                        model.prototypeSeasonalDetails.ISRComplete = false;
                    }
                    model.setMilestoneAccess();
                });
        };

        model.ldmChecked = function () {
            model.milestoneChecked("LDMComplete")
                .then(function (checked) {
                    if (checked) {
                        if (model.prototypeSeasonalDetails.LDMComplete === true && model.prototypeSeasonalDetails.ISRComplete !== true) {
                            model.prototypeSeasonalDetails.ISRComplete = true;
                            model.isrChecked();
                            return;
                        }
                    }
                    else {
                        model.prototypeSeasonalDetails.LDMComplete = false;
                    }
                    model.setMilestoneAccess();
                });
        };

        model.smChecked = function () {
            model.milestoneChecked("SMComplete")
                .then(function (checked) {
                    if (checked) {
                        if (model.prototypeSeasonalDetails.SMComplete === true && model.prototypeSeasonalDetails.LDMComplete !== true) {
                            model.prototypeSeasonalDetails.LDMComplete = true;
                            model.ldmChecked();
                            return;
                        }
                    }
                    else {
                        model.prototypeSeasonalDetails.SMComplete = false;
                    }
                    model.setMilestoneAccess();
                });
        };

        model.smFinalChecked = function () {
            model.milestoneChecked("SMFinalComplete", "SMFinalPrice", "SMFinalCmptDt")
                .then(function (checked) {
                    if (!checked) {
                        model.prototypeSeasonalDetails.SMFinalComplete = false;
                    }
                    model.setMilestoneAccess();
                });
        };

        model.milestoneFieldMap = {
            InitialPrototypeComplete: ["InitialPrototypeCompleteDate", "InitialPrototypePrice"],
            ISRComplete: ["ISRCompleteDate", "ISRPrice"],
            LDMComplete: ["LDMCompleteDate", "LDMPrice"],
            SMComplete: ["SMCompleteDate", "SMPrice"],
            SMFinalComplete: ["SMFinalCmptDt", "SMFinalPrice"]
        };

        model.costingCompleteChange = function () {
            if (!model.hasFactory) {
                model.prototypeSeasonalDetails.CostingCompl = false;
                toaster.pop({ type: "Alert", title: "Alert!", body: "You must assign a factory and save the colorway before setting Costing Complete!", timeout: 5000 });
                return false;
            }
            if (!model.canCheckMilestone(model.prototypeSeasonalDetails.CostingCompl, model.prototypeSeasonalDetails.FFC)) {
                model.prototypeSeasonalDetails.CostingCompl = false;
                toaster.pop({ type: "Alert", title: "Alert!", body: "Factory First Cost must be entered before you can set Costing Complete!", timeout: 5000 });
                return false;
            }

            if (model.prototypeSeasonalDetails.CostingCompl === true) {
                model.prototypeSeasonalDetails.CostingComplDate = moment.utc().format();
                model.prototypeSeasonalDetails.CostingComplBy = $rootScope.globals.currentUser.userId;
            } else {
                //has to be here to show in the front end
                model.prototypeSeasonalDetails.CostingComplDate = null;
            }

            if (model.prototypeSeasonalDetails.CostingCompl === true && model.prototypeSeasonalDetails.SMComplete !== true) {
                model.prototypeSeasonalDetails.SMComplete = true;
                model.smChecked();
                return;
            }
            model.setMilestoneAccess();
        };

        model.setMilestoneAccess = function () {
            if (model.prototypeSeasonalDetails) {
                model.SMDisabled = model.prototypeSeasonalDetails.CostingCompl === true;
                model.LDMDisabled = model.prototypeSeasonalDetails.SMComplete === true || model.SMDisabled;
                model.ISRDisabled = model.prototypeSeasonalDetails.LDMComplete === true || model.LDMDisabled;
                model.InitialPrototypeDisabled = model.prototypeSeasonalDetails.ISRComplete === true || model.ISRDisabled;
            }
        };

        function getPrototypeSeasonalDetails() {
            PrototypeService.getPrototypeSeasonalDetails(model.prototypeSeasonalId).then(function (ps) {
                if (!ps) {
                    $state.go('permissionDenied');
                    return;
                }

                model.prototypeSeasonalDetails = ps;

                getBrandPermissions(model.prototypeSeasonalDetails.BrandId);

                model.prototypeSeasonalDetails.ConfSmplApprEditable = model.prototypeSeasonalDetails.IsConfirmationSampleApproved == true ? false : true;
                model.prototypeSeasonalDetails.LthrApprvEditable = model.prototypeSeasonalDetails.IsLeatherApproved == true ? false : true;

                model.prototypeCurrStatusId = model.prototypeSeasonalDetails.StatusId;

                model.setMilestoneAccess();
                model.specLockReadOnly = true;

                model.CostingCompleteDisabled = ps.StatusId === 4 //Canceled
                    || (ps.IsOriginalSeason === true && ps.IsFinalSpecApprLocked !== true);

                model.hasFactory = ps.FactNameKy && ps.FactNameKy.trim().length > 0 && ps.FactName && ps.FactName.trim().length > 0;

                $scope.prototypeId = model.prototypeSeasonalDetails.PrototypeId;
                $scope.ffcCurrencySymbol = model.prototypeSeasonalDetails.FfcCurrencySymbol ? model.prototypeSeasonalDetails.FfcCurrencySymbol : "$";
                $scope.estFfcCurrencySymbol = model.prototypeSeasonalDetails.EstFfcCurrencySymbol ? model.prototypeSeasonalDetails.EstFfcCurrencySymbol : "$";

                $scope.setCurrencySymbols();

                model.ECNApplied = false;
                getLaunchList();
                getAgeCodeList();
                getProductLineList();
                getWidthList();
                getStatusList(model.prototypeSeasonalDetails.StatusId);
                getECNReasons();
                getOutsoleTechs();
                getCurrencies();

                //Manage Factory Settings
                if (model.prototypeSeasonalDetails.StatusId == 2) {
                    model.FactoryNameDisable = false;
                }
                else {
                    model.FactoryNameDisable = true;
                }

                if (model.prototypeSeasonalDetails.TransferFactoryKy) {
                    model.transferChecklistFactoryKey = model.prototypeSeasonalDetails.TransferFactoryKy;
                } else if (model.prototypeSeasonalDetails.DSFactoryKy) {
                    model.transferChecklistFactoryKey = model.prototypeSeasonalDetails.DSFactoryKy;
                }

                PrototypeService.getPrototypeDetails(model.prototypeSeasonalDetails.PrototypeId).then(function (prototypeDetails) {

                    model.prototypeDetails = prototypeDetails;
                    model.PreviousColorDesc = model.prototypeDetails.ColorDesc;
                    model.PreviousNRFColorDesc = model.prototypeDetails.NRFColorDesc;
                    model.PreviousCuttingPattern = model.prototypeDetails.CuttingPattern;
                    model.PreviousDivision = model.prototypeDetails.Division;
                    model.PreviousCollection = model.prototypeDetails.CollectionDesc;
                    model.PreviousUpperDesc = model.prototypeDetails.UpperDesc;
                    model.PreviousHierCodeLev1Desc = model.prototypeDetails.HierCodeLev1Desc;
                    model.PreviousMatlGridText = model.prototypeDetails.MatlGridText;
                    model.PreviousToeCompDesc = model.prototypeDetails.ToeCompDesc;
                    model.PreviousToeRateKey = model.prototypeDetails.ToeRateKey;
                    model.PreviousQualCat = model.prototypeDetails.QualCat;
                    model.PreviousEstFfcCurr = model.prototypeSeasonalDetails.EstFfcCurr;
                    model.PreviousUsHtsStawn = model.prototypeSeasonalDetails.UsHtsStawn;
                    model.PreviousCaHtsStawn = model.prototypeSeasonalDetails.CaHtsStawn;
                    model.PreviousUkHtsStawn = model.prototypeSeasonalDetails.UkHtsStawn;
                    model.PreviousEuHtsStawn = model.prototypeSeasonalDetails.EuHtsStawn;
                    model.PreviousStockNum = model.prototypeDetails.StockNum;

                    var statusId = model.prototypeSeasonalDetails.StatusId;
                    model.canFactoryTransfer = model.currentUser.isFactoryUser !== true && (statusId === 2 || statusId === 3 || statusId === 4 || statusId === 6);
                    model.isReadOnly = statusId === 3 || statusId === 4 || statusId === 5 || statusId === 6 || statusId === 7;
                    model.canDualSource = model.currentUser.isFactoryUser !== true && (statusId === 1 || statusId === 2 || statusId === 3);
                    model.isCarryOver = model.prototypeSeasonalDetails.ProductTypeId === 3;
                    model.isFactoryReadOnly = model.prototypeCurrStatusId !== 1 || model.prototypeDetails.IsLocked !== false;

                    isSFOverrideallowed();
                    isBrandPDMReady();
                    getSeasonList();
                    model.sapBrandId = model.prototypeDetails.SAPBrandId;

                    model.prototypeDetails.ImagePath = model.prototypeDetails.ImagePath ? model.prototypeDetails.ImagePath.trim() : "";

                    //set image name
                    model.prototypeDetails.ImagePath === ImageNotAvailableName ? model.image1 = false : model.image1 = true;
                    model.prototypeDetails.ImagePath === "" && model.prototypeDetails.ImageName === "" ? model.prototypeDetails.ImagePath = ImageNotAvailableName : '';

                    model.uploadedImage = UploadedImageUrl + model.prototypeDetails.ImagePath + model.prototypeDetails.ImageName;
                    model.prototypeImage = ImageUrl
                        + "?projectId=" + model.prototypeDetails.PrototypeId
                        + "&projectLevel=4"
                        + "&imageType=1"
                        + "&size=" + DefaultThumbnailSize + '&t=' + $filter('date')(model.prototypeDetails.ChangedOn, 'MMddyyHHmmss');

                    model.prototypeImageFull = ImageUrl
                        + "?projectId=" + model.prototypeDetails.PrototypeId
                        + "&projectLevel=4"
                        + "&imageType=1"
                        + "&size=" + DefaultEnlargeSize + '&t=' + $filter('date')(model.prototypeDetails.ChangedOn, 'MMddyyHHmmss');

                    getUsers();
                    getWFGroups();

                    //Get Pattern Spec Log Data for same season by pattern key
                    PatternService.getSpecLogData(model.prototypeDetails.PrototypeId, 4, model.prototypeSeasonalDetails.SeasonId, model.prototypeDetails.StockNum, 1).then(function (specLogDataResponse) {
                        model.specLogData = specLogDataResponse;

                        angular.forEach(model.specLogData, function (row) {
                            //check if this item in the Spec Log is flagged as ECN (null values are "false")
                            if ((row.IsECN == null ? false : true)) {
                                model.ECNApplied = true;
                            }

                        });
                    });

                    //Get Pattern Spec Log Data for different season by pattern key
                    PatternService.getSpecLogData(model.prototypeDetails.PrototypeId, 4, model.prototypeSeasonalDetails.SeasonId, model.prototypeDetails.StockNum, 0).then(function (specLogDataResponse1) {
                        model.specLogDataDiffSeason = specLogDataResponse1;
                    });

                    //Get Prototype Brief
                    PrototypeService.getPrototypeBrief(model.prototypeSeasonalId).then(function (brief) {
                        model.prototypeBriefs = [brief];
                        model.briefSeasonalId = brief.BriefSeasonalId;

                        BriefService.getBriefLinePlans(model.briefSeasonalId).then(function (briefLinePlansData) {
                            model.briefLinePlans = briefLinePlansData;
                        });
                    });

                    PrototypeService.canPrototypeShiftSeason(model.prototypeDetails.PrototypeId).then(function (data) {
                        model.canShift = data.IsSuccessful && data.Data;
                    });
                });
                //Get Prototype Patterns
                PrototypeService.getPrototypePatterns(model.prototypeSeasonalId).then(function (prototypePatternsData) {
                    model.prototypePatterns = prototypePatternsData;

                    model.prototypePatternName = model.prototypePatterns[0].PatternName + (model.prototypePatterns[0].PatternDesc ? ' / ' + model.prototypePatterns[0].PatternDesc : '');

                    if (model.prototypePatterns.length > 0) {
                        model.patternId = model.prototypePatterns[0].PatternId;
                        model.patternSeasonalId = model.prototypePatterns[0].PatternSeasonalId;
                        model.patternDevTypeId = model.prototypePatterns[0].DevelopmentType;

                        getProductTypeList(model.prototypePatterns[0].DevelopmentType);
                    } else {
                        getProductTypeList(0);
                    }

                });

                //log to last used
                var lastUsedModel = {
                    UserId: $rootScope.userId,
                    ProjectId: model.prototypeSeasonalDetails.PrototypeSeasonalId,
                    ProjectLevelId: 4
                };
                UserService.logLastUseProject(lastUsedModel);

                if (!model.prototypeSeasonalDetails.BuyReady) {
                    PrototypeService.buyReadyOverrides(model.prototypeSeasonalDetails.StockNum, model.prototypeSeasonalDetails.FactNameKy).then(function (response) {
                        if (response.length > 0) {
                            model.isBuyReadyOverridden = true;
                        }
                    });
                }
            }, function (error, status) {
                $state.go('permissionDenied');
            });
        }

        model.factoryGroupNameAndKey = function () {
            var ps = model.prototypeSeasonalDetails;
            if (ps && ps.FactoryGroupName) {
                var f = ps.FactoryGroupName;
                if (ps.FactoryGroupKey && ps.FactoryGroupKey.length > 0) {
                    f += " (" + ps.FactoryGroupKey + ")";
                }

            model.factoryGroupNameAndKeyValue = f;
        }

            return "";
        }

       // getPrototypeSeasonalDetails();

        model.onStatusChanged = function () {
            if (model.prototypeSeasonalDetails.StatusId === 2 && model.currentStatusId !== 2) {
                model.prototypeSeasonalDetails.ReleasedOn = $filter('date')(new Date(), 'MM/dd/yy');
                model.prototypeSeasonalDetails.ReleasedBy = $rootScope.userId;
                model.prototypeSeasonalDetails.ReleasedByName = $rootScope.fullName;
            }
            else if (model.prototypeSeasonalDetails.StatusId === 1) {
                model.prototypeSeasonalDetails.ReleasedOn = "";
                model.prototypeSeasonalDetails.ReleasedBy = "";
                model.prototypeSeasonalDetails.ReleasedByName = "";

            }
        };

        //Update Spec Lock Date
        model.UpdateSpecLockDate = function () {
            if (model.prototypeSeasonalDetails.IsFinalSpecApprLocked == true) {
                model.prototypeSeasonalDetails.FinalSpecApprLockedDt = $filter('date')(new Date(), 'MM/dd/yy');

            }
            else {
                model.prototypeSeasonalDetails.FinalSpecApprLockedDt = "";
            }
        };

        //Update Leather Approved Details
        model.UpdateLeatherApprovalDetails = function () {
            if (model.prototypeSeasonalDetails.LthrApprvDate) {
                model.prototypeSeasonalDetails.LthrApprvBy = $rootScope.userId;
                model.prototypeSeasonalDetails.LeatherApprovedByName = $rootScope.fullName;
            }
            else {
                model.prototypeSeasonalDetails.LthrApprvBy = "";
                model.prototypeSeasonalDetails.LeatherApprovedByName = "";
            }
        };

        model.calculateTotalVolumes = function () {
            var intlVol = 0;

            if (!isNaN(parseFloat(model.prototypeSeasonalDetails.Emea3pVolume))) {
                intlVol += parseFloat(model.prototypeSeasonalDetails.Emea3pVolume);
            }
            if (!isNaN(parseFloat(model.prototypeSeasonalDetails.AsiaVolume))) {
                intlVol += parseFloat(model.prototypeSeasonalDetails.AsiaVolume);
            }
            if (!isNaN(parseFloat(model.prototypeSeasonalDetails.LatinAVolume))) {
                intlVol += parseFloat(model.prototypeSeasonalDetails.LatinAVolume);
            }
            if (!isNaN(parseFloat(model.prototypeSeasonalDetails.EmeaDistVolume))) {
                intlVol += parseFloat(model.prototypeSeasonalDetails.EmeaDistVolume);
            }

            model.prototypeSeasonalDetails.IntnlVolume = intlVol;

            model.calculateTotalVolume();
        };

        model.calculateTotalVolume = function () {
            var estimatedVol = 0;

            if (!isNaN(parseFloat(model.prototypeSeasonalDetails.USVolume))) {
                estimatedVol += parseFloat(model.prototypeSeasonalDetails.USVolume);
            }
            if (!isNaN(parseFloat(model.prototypeSeasonalDetails.EmeaDistVolume))) {
                estimatedVol += parseFloat(model.prototypeSeasonalDetails.EmeaDistVolume);
            }
            if (!isNaN(parseFloat(model.prototypeSeasonalDetails.CAVolume))) {
                estimatedVol += parseFloat(model.prototypeSeasonalDetails.CAVolume);
            }
            if (!isNaN(parseFloat(model.prototypeSeasonalDetails.NaDtcStoreVolume))) {
                estimatedVol += parseFloat(model.prototypeSeasonalDetails.NaDtcStoreVolume);
            }
            if (!isNaN(parseFloat(model.prototypeSeasonalDetails.NaDtcEcomVolume))) {
                estimatedVol += parseFloat(model.prototypeSeasonalDetails.NaDtcEcomVolume);
            }
            if (!isNaN(parseFloat(model.prototypeSeasonalDetails.EuDtcVolume))) {
                estimatedVol += parseFloat(model.prototypeSeasonalDetails.EuDtcVolume);
            }
            if (!isNaN(parseFloat(model.prototypeSeasonalDetails.EmeaOwnedVolume))) {
                estimatedVol += parseFloat(model.prototypeSeasonalDetails.EmeaOwnedVolume);
            }
            if (!isNaN(parseFloat(model.prototypeSeasonalDetails.Emea3pVolume))) {
                estimatedVol += parseFloat(model.prototypeSeasonalDetails.Emea3pVolume);
            }
            if (!isNaN(parseFloat(model.prototypeSeasonalDetails.AsiaVolume))) {
                estimatedVol += parseFloat(model.prototypeSeasonalDetails.AsiaVolume);
            }
            if (!isNaN(parseFloat(model.prototypeSeasonalDetails.LatinAVolume))) {
                estimatedVol += parseFloat(model.prototypeSeasonalDetails.LatinAVolume);
            }

            model.prototypeSeasonalDetails.TotalVolume = estimatedVol;
        };

        model.checkStockNumber = function (validateField) {
            if (model.prototypeSeasonalDetails.ProductTypeId != 3 &&
                model.prototypeSeasonalDetails.ProductTypeId > 0 &&
                model.prototypeDetails.StockNum !== "") {
                model.needToValidate = true;

                PrototypeService.isStockNumberExists(model.prototypeDetails.PrototypeId,
                    model.prototypeSeasonalDetails.PrototypeSeasonalId,
                    model.prototypeSeasonalDetails.SeasonId,
                    model.prototypeDetails.StockNum,
                    model.prototypeSeasonalDetails.FactNameKy).then(function (stockNumExistsResponse) {
                        if (stockNumExistsResponse.Data) {

                            model.stockNumberResponse = stockNumExistsResponse.Message;

                            switch (validateField) {
                                case 1:
                                    $scope.prototypeEditForm.$setValidity('stockNumberExistsPTG', false);
                                    break;
                                case 2:
                                    $scope.prototypeEditForm.$setValidity('stockNumberExistsSN', false);
                                    break;
                            }
                            saveAfter(true);
                        } else {
                            $scope.prototypeEditForm.$setValidity('stockNumberExistsPTG', true);
                            $scope.prototypeEditForm.$setValidity('stockNumberExistsSN', true);
                            $scope.prototypeEditForm.$setValidity('factKeyInvalid2', true);
                            saveAfter();
                        }
                    });
            }

            if (model.prototypeDetails.StockNum == "") {
                $scope.prototypeEditForm.$setValidity('stockNumberExistsSN', true);
                saveAfter();
            }

            if (model.prototypeSeasonalDetails.FactNameKy == "") {
                $scope.prototypeEditForm.$setValidity('stockNumberExistsPTG', true);
                $scope.prototypeEditForm.$setValidity('factKeyInvalid2', true);
            }
        };

        model.checkPrototypeName = function (scope) {
            //scope.prototypeEditForm.prototypeName.$setValidity('prototypeNameExists', true);
            var prototypeName = model.prototypeDetails.PrototypeName;
            toaster.clear();
            PrototypeService.isPrototypeNameExists(model.prototypeDetails.PrototypeId, prototypeName, model.prototypeDetails.BrandId, model.prototypeSeasonalDetails.SeasonId)
                .then(function (response) {
                    if (response == true) {
                        //scope.prototypeEditForm.prototypeName.$setValidity('prototypeNameExists', false);
                        toaster.pop({
                            type: 'note',
                            title: 'Name duplication',
                            body: 'You may continue, but please note this name already exists.',
                            timeout: 5000
                        });
                    }
                });
        }

        function saveAfter(dontSave) {
            model.needToValidate = false; //no more need to validate since this runs after call to SAP is complete
            if ($scope.saveClicked) { //will only run this if save was clicked
                if (dontSave) { //reset saveClicked after save is compelte (only call on save return)
                    $scope.saveClicked = false;
                } else {
                    //if save was clicked but dontSave is false
                    model.Save($scope.prototypeEditForm.$invalid); //run the save
                }
            }

        }

        // get service fee , assign it and also calculate the purchase price
        model.getServFee = true;
        model.getServiceFee = function (a) {
            PrototypeService.getServiceFee(model.sapBrandId, model.prototypeSeasonalDetails.FactNameKy).then(function (response) {
                model.ServFee = response;

                if (model.ServFee >= 0) {
                    model.prototypeSeasonalDetails.ServFee = model.ServFee;
                    model.calculatePrices();
                } else {
                    toaster.pop({
                        type: 'Warning',
                        title: 'Warning!',
                        body: 'No Service Fee found.',
                        timeout: 5000
                    });
                }
                model.getServFee = false;
                if (a) {
                    model.Save($scope.prototypeEditForm.$invalid); //run the save

                }
            });
        }

        //Save Prototype Header and Details
        model.Save = function (isFormInvalid) {
            $scope.saveClicked = true;
            if (model.needToValidate) {
                return;
            }

            if (!isFormInvalid) {

                //calculate service fee every time we save
                if (model.getServFee === true) {
                    model.getServiceFee(true);
                    return;
                }

                if (model.prototypeSeasonalDetails.StatusId == 2 && (model.prototypeSeasonalDetails.FactNameKy == "" || model.prototypeSeasonalDetails.FactNameKy == null)) {
                    toaster.pop({ type: 'error', title: 'Error!', body: 'Please select Factory Name', timeout: 5000 });

                    $scope.prototypeEditForm.$setPristine();
                    $scope.prototypeEditForm.$setUntouched();
                }
                else {
                    $scope.prototypeEditForm.$setPristine();
                    var accountableId = model.prototypeSeasonalDetails.ResponsibleId;
                    var statusId = model.prototypeSeasonalDetails.StatusId;

                    if (model.PrototypeRRAssignment) {
                        if (model.prototypeSeasonalDetails.ResponsibleName.Id) {
                            accountableId = model.prototypeSeasonalDetails.ResponsibleName.Id;
                        }
                    }

                    if (model.PrototypeStatusChange) {
                        statusId = model.prototypeSeasonalDetails.StatusId;
                    }

                    if (accountableId == 'undefined' || accountableId != null || accountableId != "") {

                        var estCompleteDate = "";
                        var actComplDate = "";
                        var releasedOn = "";
                        var prePrdAuthDt = "";
                        var prodAuthDt = "";
                        var confSmplApprDt = "";
                        var specLockDt = "";
                        var lthrApprvDate = "";

                        if (model.prototypeDetails.EstCompleteDate) {
                            estCompleteDate = $filter('date')(model.prototypeDetails.EstCompleteDate, "M/dd/yyyy");
                        }

                        if (model.prototypeDetails.ActComplDate) {
                            actComplDate = $filter('date')(model.prototypeDetails.ActComplDate, "M/dd/yyyy");
                        }

                        if (model.prototypeSeasonalDetails.ReleasedOn) {
                            releasedOn = $filter('date')(model.prototypeSeasonalDetails.ReleasedOn, "M/dd/yyyy");
                        }

                        if (model.prototypeDetails.PrePrdAuthDt) {
                            prePrdAuthDt = $filter('date')(model.prototypeDetails.PrePrdAuthDt, "M/dd/yyyy");
                        }

                        if (model.prototypeDetails.ProdAuthDt) {
                            prodAuthDt = $filter('date')(model.prototypeDetails.ProdAuthDt, "M/dd/yyyy");
                        }

                        model.prototypeData = {
                            PrototypeId: model.prototypeDetails.PrototypeId,
                            PrototypeName: model.prototypeDetails.PrototypeName,
                            EstCompleteDate: estCompleteDate,
                            ActComplDate: actComplDate,
                            FactRefNum: model.prototypeDetails.FactRefNum,
                            DevColorNm: model.prototypeDetails.DevColorNm,
                            SAPPattNmAbr: model.prototypeDetails.SAPPattNmAbr,
                            ColorKey: model.prototypeDetails.ColorKey,
                            ColorDesc: model.prototypeDetails.ColorDesc,
                            NRFColorKey: model.prototypeDetails.NRFColorKey,
                            NRFColorDesc: model.prototypeDetails.NRFColorDesc,
                            ProdLine: model.prototypeDetails.ProdLine,
                            StockNum: model.prototypeDetails.StockNum,
                            PictogrmLbl: model.prototypeDetails.PictogrmLbl,
                            UpperDesc: model.prototypeDetails.UpperDesc,
                            LiningDesc: model.prototypeDetails.LiningDesc,
                            OutsoleDesc: model.prototypeDetails.OutsoleDesc,
                            MatlGridNum: model.prototypeDetails.MatlGridNum,
                            MatlGridText: model.prototypeDetails.MatlGridText,
                            ToeCompKey: model.prototypeDetails.ToeCompKey,
                            ToeCompDesc: model.prototypeDetails.ToeCompDesc,
                            SafetyToe: model.prototypeDetails.SafetyToe,
                            ToeRateKey: model.prototypeDetails.ToeRateKey,
                            QualCat: model.prototypeDetails.QualCat,
                            Width: model.prototypeDetails.Width,
                            SampWght: model.prototypeDetails.SampWght,
                            PrePrdAuthDt: prePrdAuthDt,
                            PrePrdAuthNum: model.prototypeDetails.PrePrdAuthNum,
                            ProdAuthDt: prodAuthDt,
                            ProdAuthNum: model.prototypeDetails.ProdAuthNum,
                            GenNotes: model.prototypeDetails.GenNotes,
                            UsComp: model.prototypeDetails.UsComp,
                            UsCompVal: model.prototypeDetails.UsCompVal,
                            DualSrcdPatt: model.prototypeDetails.DualSrcdPatt,
                            BuyReady: model.prototypeDetails.BuyReady,
                            AgeCode: model.prototypeDetails.AgeCode,
                            FWS: model.prototypeDetails.FWS,
                            HierCodeLev1Key: model.prototypeDetails.HierCodeLev1Key,
                            HierCodeLev1Desc: model.prototypeDetails.HierCodeLev1Desc,
                            ReferneceNumber: model.prototypeDetails.ReferneceNumber,
                            CuttingPattern: model.prototypeDetails.CuttingPattern,
                            CompStyleStockNumber: model.prototypeDetails.CompStyleStockNumber,
                            IsLocked: model.prototypeDetails.IsLocked,
                            Division: model.prototypeDetails.Division,
                            DivisionKey: model.prototypeDetails.DivisionKey,
                            CollectionDesc: model.prototypeDetails.CollectionDesc,
                            CollectionNum: model.prototypeDetails.CollectionNum,
                            BusinessSeg: model.prototypeDetails.BusinessSeg,
                            BasicMaterial: model.prototypeDetails.BasicMaterial,
                            CustomerKey: model.prototypeDetails.CustomerKey,
                            CustomerNam: model.prototypeDetails.CustomerNam,
                            StoryTypeKey: model.prototypeDetails.StoryTypeKey,
                            StoryType: model.prototypeDetails.StoryType,
                            ConsumerTerritory: model.prototypeDetails.ConsumerTerritory,
                            ConsumerTerritoryKey: model.prototypeDetails.ConsumerTerritoryKey
                        };



                        $scope.today = $filter('date')(new Date(), 'yyyy-MM-dd');
                        if (model.prototypeSeasonalDetails.LDMComplete == true && model.prototypeSeasonalDetails.LDMCompleteDate == null) {
                            model.prototypeSeasonalDetails.LDMCompleteDate = $scope.today;  //Date.now();
                        }
                        if (model.prototypeSeasonalDetails.LDMComplete == false && model.prototypeSeasonalDetails.LDMCompleteDate != null) {
                            model.prototypeSeasonalDetails.LDMCompleteDate = null;
                        }

                        if (model.prototypeSeasonalDetails.ISRComplete == true && model.prototypeSeasonalDetails.ISRCompleteDate == null) {
                            model.prototypeSeasonalDetails.ISRCompleteDate = $scope.today;  //Date.now();
                        }
                        if (model.prototypeSeasonalDetails.ISRComplete == false && model.prototypeSeasonalDetails.ISRCompleteDate != null) {
                            model.prototypeSeasonalDetails.ISRCompleteDate = null;
                        }

                        if (model.prototypeSeasonalDetails.SMComplete == true && model.prototypeSeasonalDetails.SMCompleteDate == null) {
                            model.prototypeSeasonalDetails.SMCompleteDate = $scope.today;  //Date.now();
                        }
                        if (model.prototypeSeasonalDetails.SMComplete == false && model.prototypeSeasonalDetails.SMCompleteDate != null) {
                            model.prototypeSeasonalDetails.SMCompleteDate = null;
                        }

                        if (model.prototypeSeasonalDetails.SMFinalComplete == true && model.prototypeSeasonalDetails.SMFinalCmptDt == null) {
                            model.prototypeSeasonalDetails.SMFinalCmptDt = $scope.today;  //Date.now();
                        }
                        if (model.prototypeSeasonalDetails.SMFinalComplete == false && model.prototypeSeasonalDetails.SMFinalCmptDt != null) {
                            model.prototypeSeasonalDetails.SMFinalCmptDt = null;
                        }

                        if (model.prototypeSeasonalDetails.ConfSmplApprDt) {
                            confSmplApprDt = $filter('date')(model.prototypeSeasonalDetails.ConfSmplApprDt, "M/dd/yyyy");
                        }

                        if (model.prototypeSeasonalDetails.FinalSpecApprLockedDt) {
                            specLockDt = $filter('date')(model.prototypeSeasonalDetails.FinalSpecApprLockedDt, "M/dd/yyyy");
                        }

                        if (model.prototypeSeasonalDetails.LthrApprvDate) {
                            lthrApprvDate = $filter('date')(model.prototypeSeasonalDetails.LthrApprvDate, "M/dd/yyyy");
                        }

                        model.prototypeSeasonalData = {
                            PrototypeSeasonalId: model.prototypeSeasonalDetails.PrototypeSeasonalId,
                            SeasonId: model.prototypeSeasonalDetails.SeasonId,
                            UsHtsStawn: model.prototypeSeasonalDetails.UsHtsStawn,
                            UsAssignDuty: model.prototypeSeasonalDetails.UsAssignDuty,
                            UsHtsCodeKey: model.prototypeSeasonalDetails.UsHtsCodeKey,
                            CaHtsStawn: model.prototypeSeasonalDetails.CaHtsStawn,
                            CaAssignDuty: model.prototypeSeasonalDetails.CaAssignDuty,
                            CaHtsCodeKey: model.prototypeSeasonalDetails.CaHtsCodeKey,
                            UkHtsStawn: model.prototypeSeasonalDetails.UkHtsStawn,
                            UkAssignDuty: model.prototypeSeasonalDetails.UkAssignDuty,
                            UkHtsCodeKey: model.prototypeSeasonalDetails.UkHtsCodeKey,
                            EuHtsStawn: model.prototypeSeasonalDetails.EuHtsStawn,
                            EuAssignDuty: model.prototypeSeasonalDetails.EuAssignDuty,
                            EuHtsCodeKey: model.prototypeSeasonalDetails.EuHtsCodeKey,
                            StatusId: model.prototypeSeasonalDetails.StatusId,
                            ResponsibleId: model.prototypeSeasonalDetails.ResponsibleId,
                            FactNameKy: model.prototypeSeasonalDetails.FactNameKy,
                            FactName: model.prototypeSeasonalDetails.FactName,
                            CtryOfOrig: model.prototypeSeasonalDetails.CtryOfOrig,
                            FactoryGroupKey: model.prototypeSeasonalDetails.FactoryGroupKey,
                            FactoryGroupName: model.prototypeSeasonalDetails.FactoryGroupName,
                            EstFFC: model.prototypeSeasonalDetails.EstFFC,
                            EstFfcCurr: model.prototypeSeasonalDetails.EstFfcCurr,
                            EstPurPrice: model.prototypeSeasonalDetails.EstPurPrice,
                            FfcCurr: model.prototypeSeasonalDetails.FfcCurr,
                            FFC: model.prototypeSeasonalDetails.FFC,
                            ActPurPrice: model.prototypeSeasonalDetails.ActPurPrice,
                            CostingCompl: model.prototypeSeasonalDetails.CostingCompl,
                            CostingComplDate: model.prototypeSeasonalDetails.CostingComplDate,
                            CostingComplBy: model.prototypeSeasonalDetails.CostingComplBy,
                            ServFee: model.prototypeSeasonalDetails.ServFee,
                            ProductTypeId: model.prototypeSeasonalDetails.ProductTypeId,
                            USVolume: model.prototypeSeasonalDetails.USVolume,
                            CAVolume: model.prototypeSeasonalDetails.CAVolume,
                            EmeaOwnedVolume: model.prototypeSeasonalDetails.EmeaOwnedVolume,
                            EmeaDistVolume: model.prototypeSeasonalDetails.EmeaDistVolume,
                            NaDtcStoreVolume: model.prototypeSeasonalDetails.NaDtcStoreVolume,
                            NaDtcEcomVolume: model.prototypeSeasonalDetails.NaDtcEcomVolume,
                            ItalyVolume: model.prototypeSeasonalDetails.ItalyVolume,
                            EuDtcVolume: model.prototypeSeasonalDetails.EuDtcVolume,
                            Emea3pVolume: model.prototypeSeasonalDetails.Emea3pVolume,
                            AsiaVolume: model.prototypeSeasonalDetails.AsiaVolume,
                            CNVolume: model.prototypeSeasonalDetails.CNVolume,
                            HKVolume: model.prototypeSeasonalDetails.HKVolume,
                            C4CVolume: model.prototypeSeasonalDetails.C4CVolume,
                            LatinAVolume: model.prototypeSeasonalDetails.LatinAVolume,
                            IntnlVolume: model.prototypeSeasonalDetails.IntnlVolume,
                            TotalVolume: model.prototypeSeasonalDetails.TotalVolume,
                            Launch: "",
                            LinePlanLaunchDateId: model.prototypeSeasonalDetails.LinePlanLaunchDateId,
                            MitigAdjustment: model.prototypeSeasonalDetails.MitigAdjustment,
                            FactoryTransfer: model.prototypeSeasonalDetails.FactoryTransfer,
                            HTSNotes: model.prototypeSeasonalDetails.HTSNotes,
                            WFGroupId: model.prototypeSeasonalDetails.WFGroupId,
                            LDMComplete: model.prototypeSeasonalDetails.LDMComplete,
                            ISRComplete: model.prototypeSeasonalDetails.ISRComplete,
                            SMComplete: model.prototypeSeasonalDetails.SMComplete,
                            SMFinalComplete: model.prototypeSeasonalDetails.SMFinalComplete,
                            SFOverride: model.prototypeSeasonalDetails.SFOverride,
                            LDMPrice: model.prototypeSeasonalDetails.LDMPrice,
                            ISRPrice: model.prototypeSeasonalDetails.ISRPrice,
                            SMPrice: model.prototypeSeasonalDetails.SMPrice,
                            SMFinalPrice: model.prototypeSeasonalDetails.SMFinalPrice,
                            LDMCompleteDate: model.prototypeSeasonalDetails.LDMCompleteDate,
                            ISRCompleteDate: model.prototypeSeasonalDetails.ISRCompleteDate,
                            SMCompleteDate: model.prototypeSeasonalDetails.SMCompleteDate,
                            SMFinalCmptDt: model.prototypeSeasonalDetails.SMFinalCmptDt,
                            RSComplete: model.prototypeSeasonalDetails.RSComplete,
                            PerformanceLvl: model.prototypeSeasonalDetails.PerformanceLvl,
                            IsSFOverride: model.prototypeSeasonalDetails.IsSFOverride,
                            FinalSpecApprLockedDt: specLockDt,
                            ConfSmplApprDt: confSmplApprDt,
                            ConfNotes: model.prototypeSeasonalDetails.ConfNotes,
                            LthrApprvDate: lthrApprvDate,
                            ReleasedOn: releasedOn,
                            ReleasedBy: model.prototypeSeasonalDetails.ReleasedBy,
                            InitialPrototypeComplete: model.prototypeSeasonalDetails.InitialPrototypeComplete,
                            InitialPrototypeCompleteDate: model.prototypeSeasonalDetails.InitialPrototypeCompleteDate,
                            InitialPrototypePrice: model.prototypeSeasonalDetails.InitialPrototypePrice,
                            OutsoleTechCode: model.prototypeSeasonalDetails.OutsoleTechCode,
                            CriticalPathDevPrototypeId: model.prototypeSeasonalDetails.CriticalPathDevPrototypeId,
                            ColorMin: model.prototypeSeasonalDetails.ColorMin
                        };

                        model.specLogData = {
                            ProjectId: model.prototypeDetails.PrototypeId,
                            ProjectLevelId: 4,
                            Description: model.specLogDescription,
                            SeasonId: model.prototypeSeasonalDetails.SeasonId,
                            IsECN: model.IsECN,
                            CreatedBy: $rootScope.userId
                        };

                        PrototypeService.updatePrototypeData(model.prototypeData, model.prototypeSeasonalData, model.specLogData, model.sizeRanges)
                            .then(function (response) {
                                if (response.IsSuccessful) {
                                    toaster.pop({ type: 'success', title: 'Success!', body: response.Message, timeout: 5000 });

                                    model.needToValidate = false;
                                    model.specLogDescription = "";
                                    model.IsECN = false;

                                    model.getServFee = true;

                                    //this is bound to sales-forecast-grid directive
                                    if (model.reloadSalesForecasting)
                                        model.reloadSalesForecasting();

                                    PatternService.getSpecLogData(model.prototypeDetails.PrototypeId, 4, model.prototypeSeasonalDetails.SeasonId, model.prototypeDetails.StockNum, 1).then(function (specLogDataResponse) {
                                        model.specLogData = specLogDataResponse;
                                    });

                                    PatternService.getSpecLogData(model.prototypeDetails.PrototypeId, 4, model.prototypeSeasonalDetails.SeasonId, model.prototypeDetails.StockNum, 0).then(function (specLogDataResponse1) {
                                        model.specLogDataDiffSeason = specLogDataResponse1;
                                    });

                                    getPrototypeSeasonalDetails();
                                    model.updateDirectives = model.updateDirectives ? false : true;
                                }
                                else {
                                    toaster.pop({ type: 'error', title: 'Error!', body: response.Message || 'There was an error while saving the record. Please contact system administrator', timeout: 5000 });
                                }
                                $scope.saveClicked = false;
                                $scope.prototypeEditForm.$setPristine();
                                $scope.prototypeEditForm.$setUntouched();
                            }, function (error, status) {
                                toaster.pop({ type: 'error', title: 'Error!', body: typeof error === 'string' ? error : error.Message, timeout: 5000 });
                                $scope.saveClicked = false;
                                $scope.prototypeEditForm.$setPristine();
                                $scope.prototypeEditForm.$setUntouched();
                            });
                    }
                    else {
                        toaster.pop({ type: 'error', title: 'Error!', body: 'User Id is missing', timeout: 5000 });
                    }
                }
            }
            else {
                if (!model.needToValidate) {
                    toaster.pop({ type: 'error', title: 'Error!', body: 'Please review all fields indicated in red', timeout: 5000 });
                    saveAfter(true);
                }
            }
        };

        model.calculatePrices = function () {
            var ps = model.prototypeSeasonalDetails;

            var sf = ps.IsSFOverride === true ? ps.SFOverride : ps.ServFee;
            if (ps.FFC >= 0) {
                ps.FfcPct = ps.FFC * (sf / 100);
                ps.ActPurPrice = ps.FFC + parseFloat(ps.FfcPct.toFixed(2));
            }

            if (ps.EstFFC >= 0) {
                ps.EstFfcPct = ps.EstFFC * (sf / 100);
                ps.EstPurPrice = ps.EstFFC + parseFloat(ps.EstFfcPct.toFixed(2));
            }
        };

        model.ApplyECN = function () {
            var reason = $.grep(model.ECNReasons, function (r) { return r.ReasonId == model.reasonForChange; });
            var reasonDesc = reason.length == 1 ? reasonDesc = reason[0].Description : model.reasonForChange;

            model.specLogDescription = 'ECN Process applied for reason: ' + reasonDesc + '.';
            if (model.ecnNotes && model.ecnNotes.length > 0)
                model.specLogDescription += '  Additional user comments: ' + model.ecnNotes;
            model.IsECN = true;
        };

        /*Start of Upload Image Section*/
        function clearImageUpload() {
            model.imageInterface = {};
            document.getElementById('file').value = null;
        }

        //Browse Image and Upload
        $scope.selectImage = function (e) {
            uploadImage(e.files[0], 'browse');
        };

        //Drag and Drop image and upload
        model.addImage = function (file) {
            uploadImage(file.file, 'dragdrop');
        };

        //Upload Image
        function uploadImage(file, source) {
            model.isImageError = "";
            model.isImageUploadSuccess = "";
            $scope.prototypeEditForm.$setDirty();

            model.file = file;

            var ext = model.file.name.substr(model.file.name.lastIndexOf('.') + 1).toLowerCase();
            var errors = 0;

            if (model.validImageExtensions.indexOf(ext) == -1) {
                errors++;
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'Invalid File Format',
                    timeout: 5000
                });
            }

            if (file.name.length > 175) {
                errors++;
                var a = file.files[0].name.length - 175;
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'File name is ' + a + ' characters over the maximum amount of 175. Please rename your file, and try again.',
                    timeout: 5000
                });
                //remove file from droplet
                clearImageUpload();
            }

            if (errors == 0) {
                model.prototypeImage = "";

                var imageMeta = {
                    ProjectId: model.prototypeSeasonalDetails.PrototypeId,
                    ProjectLevel: 4,
                    ImageType: 1
                };

                ImageService.uploadImage(model.file, imageMeta)
                    .then(function (response) {

                        clearImageUpload();

                        response.ImageName == ImageNotAvailableName ? model.image1 = false : model.image1 = true;
                        model.uploadedImage = UploadedImageUrl + response.ImagePath + response.ImageName;

                        model.prototypeImage = ImageUrl
                            + "?projectId=" + model.prototypeDetails.PrototypeId
                            + "&projectLevel=4"
                            + "&imageType=1"
                            + "&size=" + DefaultThumbnailSize + '&t=' + $filter('date')(new Date(), 'MMddyyHHmmss');

                        //reset set enlarged thumbnail image
                        model.prototypeImageFull = ImageUrl
                            + "?projectId=" + model.prototypeDetails.PrototypeId
                            + "&projectLevel=4"
                            + "&imageType=1"
                            + "&size=" + DefaultThumbnailSize + '&t=' + $filter('date')(new Date(), 'MMddyyHHmmss');

                        toaster.pop({
                            type: 'success',
                            title: 'Success!',
                            body: 'Image uploaded successfully',
                            timeout: 5000
                        });
                    }, function (error, status) {
                        model.prototypeImage = ImageUrl + model.prototypeDetails.ImageName + model.prototypeDetails.ImageName;
                        toaster.pop({
                            type: 'error',
                            title: 'Error!',
                            body: 'There was an error while uploading the image. Please contact system administrator. Error Message: ' + error.ExceptionMessage,
                            timeout: 5000
                        });
                        clearImageUpload();
                    });
            }

            $scope.prototypeEditForm.$setPristine();
            $scope.prototypeEditForm.$setUntouched();
        }
        model.deleteImage = function (projectId, projectLevel, imageType) {
            ImageService.deleteImage(projectId, projectLevel, imageType)
                .then(function (response) {
                    toaster.pop({
                        type: 'success',
                        title: 'Success!',
                        body: "Image Deleted Successfully",
                        timeout: 5000
                    });

                    //clear the image
                    model.image1 = false;

                    var date = new Date();
                    var t = date.getTime();
                    model.timeStamp = t;

                    //reset current image
                    model.uploadedImage = UploadedImageUrl + ImageNotAvailableName

                    //reset set thumbnail image
                    model.prototypeImage = ImageUrl
                        + "?projectId=" + model.prototypeDetails.PrototypeId
                        + "&projectLevel=4"
                        + "&imageType=1"
                        + "&size=" + DefaultThumbnailSize + '&t=' + $filter('date')(new Date(), 'MMddyyHHmmss');

                    //reset set enlarged thumbnail image
                    model.prototypeImageFull = ImageUrl
                        + "?projectId=" + model.prototypeDetails.PrototypeId
                        + "&projectLevel=4"
                        + "&imageType=1"
                        + "&size=" + DefaultThumbnailSize + '&t=' + $filter('date')(new Date(), 'MMddyyHHmmss');

                }, function (error, status) {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: "There was an error while deleting the image. Please contact system administrator.",
                        timeout: 5000
                    });
                });
        };
        /* End of Upload Image Section*/

        model.deletePrototypeSeasonal = function () {
            PrototypeService.deletePrototypeSeasonal(model.prototypeSeasonalId).then(function (response) {
                if (response.IsSuccessful) {
                    toaster.pop({
                        type: 'success',
                        title: 'Success!',
                        body: 'Record Deleted Successfully.',
                        timeout: 5000
                    });
                    $state.go('Search');
                } else {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'Record was not deleted. Please check current status.',
                        timeout: 5000
                    });
                }

            },
                function (error, status) {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'There was an error while deleting the record. Please contact your administrator.',
                        timeout: 5000
                    });
                }
            );
        };

        model.List = function () {
            $state.go("Search");
        };

        model.View = function () {
            $state.go("colorway", { prototypeSeasonalId: model.prototypeSeasonalId });
        };

        model.Copy = function () {
            $state.go("prototypeCopy", { parentPrototypeSeasonalId: model.prototypeSeasonalId });
        };

        model.refreshImageCache = function () {
            $scope.refreshingImage = true;

            var imgUrl = model.prototypeImage + "&r=" + Math.random();
            var imgFullUrl = model.prototypeImageFull + "&r=" + Math.random();

            model.prototypeImage = ImageService.defaultImageUrl(DefaultThumbnailSize);
            model.prototypeImageFull = ImageService.defaultImageUrl(DefaultEnlargeSize);

            ImageService.invalidateCache(model.prototypeDetails.PrototypeId, 4).then(function () {
                WebApiService.get(imgUrl).then(function () {
                    model.prototypeImage = imgUrl;
                    model.prototypeImageFull = imgFullUrl;
                    $scope.refreshingImage = false;
                });
            });
        };

        model.getImage = function (projectId, projectLevel, imageType, type) {
            var date = new Date();
            switch (type) {
                case 1:
                    return ImageUrl
                        + "?projectId=" + projectId
                        + "&projectLevel=" + projectLevel
                        + "&imageType=" + imageType
                        + "&size=" + 70 + '&t=' + $filter('date')(date, 'MMddyyHHmmss');
                    break;
                case 2:
                    return ImageUrl
                        + "?projectId=" + projectId
                        + "&projectLevel=" + projectLevel
                        + "&imageType=" + imageType
                        + "&size=" + DefaultEnlargeSize + '&t=' + $filter('date')(date, 'MMddyyHHmmss');
                    break;
            }
        }

        model.RelinkClicked = function () {
            model.relinkIssuesList = [];
            SeasonService.getProjectsSeasons(model.prototypeDetails.PrototypeId, 4).then(function (response) {
                if (response && response.length != 1) {
                    model.relinkIssuesList.push({
                        "IssueText": "The colorway must exist in only one season to relink"
                    });
                } else {
                    model.loadPatterns();
                }
                $('#relinkModal').modal('show');
            });
        };

        model.FactoryTransferButtonClicked = function () {
            model.FactoryTransferPopUpTitle = 'Factory Transfer';
            model.ButtonTransferTitle = 'Yes, Transfer';
            model.FactoryTransferOrDualSource = 'FACTORYTRANSFER';
            model.FactoryTransferClicked();
        };

        model.DualSourceButtonClicked = function () {
            model.FactoryTransferPopUpTitle = 'Dual Source';
            model.ButtonTransferTitle = 'Yes, Dual Source';
            model.FactoryTransferOrDualSource = 'DUALSOURCE';
            model.FactoryTransferClicked();
        };

        model.FactoryTransferClicked = function () {
            var modalSearch = SearchFactory.factorySearch(function (factory) {
                model.selectedFactory = factory;
                return false;
            });

            modalSearch.title = model.FactoryTransferPopUpTitle;
            modalSearch.showCancel = true;
            modalSearch.cancelText = "No, Cancel";
            modalSearch.buttons = [{
                click: function () {
                    modalSearch.hideSearch();
                    model.DoFactoryTransfer();
                },
                disabled: function () {
                    return !model.selectedFactory;
                },
                dismiss: "modal",
                text: model.ButtonTransferTitle
            }];

            modalSearch.startSearch(false, [""]);
        };

        model.DoFactoryTransfer = function () {
            var factory = model.selectedFactory;

            if (!factory)
                return;

            model.factoryKey = factory.FactoryKey;
            model.factoryName = factory.FactoryName;
            model.countryKey = factory.CountryCode;
            model.factoryGroupKey = factory.FactoryGroupKey || "";
            model.factoryGroupName = factory.FactoryGroupName || "";

            model.isTariffMitigation = false;
            model.copyBuyReady = (!!model.prototypeSeasonalDetails.FactoryGroupKey && !!factory.FactoryGroupKey && model.prototypeSeasonalDetails.FactoryGroupKey === factory.FactoryGroupKey);
            model.forceCopyBuyReady = model.copyBuyReady;

            $('#tariffMitigationTransferModal').modal('show');
        };

        model.FinishTransfer = function () {
            if (model.FactoryTransferOrDualSource === 'FACTORYTRANSFER') {
                PrototypeService.FactoryTransferUpdate(
                    model.prototypeSeasonalDetails.PrototypeSeasonalId, model.factoryKey, model.countryKey, model.factoryName, model.factoryGroupKey, model.factoryGroupName, model.isTariffMitigation, model.copyBuyReady)
                    .then(function (response) {
                        if (response.Result === 0) {
                            toaster.pop({ type: 'success', title: 'Success!', body: 'Factory Transfer completed successfully.', timeout: 5000 });

                            $scope.prototypeEditForm.$setPristine();
                            $scope.prototypeEditForm.$setUntouched();

                            if (model.prototypeSeasonalDetails.PrototypeSeasonalId === response.Data) {
                                getPrototypeSeasonalDetails();
                            } else {
                                $state.go('colorway', { 'prototypeSeasonalId': response.Data });
                            }
                        } else {
                            toaster.pop({ type: 'error', title: 'Error!', body: response.Message, timeout: 5000 });
                        }
                    }, function (response) {
                        toaster.pop({ type: 'error', title: 'Error!', body: response.Message, timeout: 5000 });
                    });
            }
            else if (model.FactoryTransferOrDualSource === 'DUALSOURCE') {
                PrototypeService.DualSourceUpdate(
                    model.prototypeSeasonalDetails.PrototypeSeasonalId, model.factoryKey, model.countryKey, model.factoryName, $rootScope.userId, model.factoryGroupKey, model.factoryGroupName, model.isTariffMitigation, model.copyBuyReady)
                    .then(function (response) {
                        if (response.IsSuccessful) {
                            toaster.pop({ type: 'success', title: 'Success!', body: 'Dual Source completed successfully', timeout: 5000 });
                            $scope.prototypeEditForm.$setPristine();
                            $scope.prototypeEditForm.$setUntouched();
                            $state.go('colorway', { 'prototypeSeasonalId': response.Data });
                        }
                        else {
                            toaster.pop({ type: 'error', title: 'Error!', body: response.Message, timeout: 5000 });
                        }
                    }, function () {
                        toaster.pop({ type: 'error', title: 'Error!', body: response, timeout: 5000 });
                    });
            }
        };

        model.Do_Relink = function () {
            PrototypeService.relinkPrototype(model.prototypeDetails.PrototypeId, model.relinkPatternId, model.prototypePatterns[0].PatternId).then(function (response) {
                if (response.IsSuccessful) {
                    $state.reload();
                    toaster.pop({ type: 'success', title: 'Success!', body: 'Relink succeeded.', timeout: 5000 });
                }
                else {
                    toaster.pop({ type: 'error', title: 'Error', body: 'Re-link failed. ' + response.Message, timeout: 5000 });
                }
            });
        };

        model.loadPatterns = function () {
            model.loadingPatterns = true;

            PatternService.getPatternsByBrandSeason(model.prototypeDetails.BrandId, model.prototypeSeasonalDetails.SeasonId, 0).then(function (response) {
                model.patternsForRelink = response ? response : [];
                model.loadingPatterns = false;
            });
        };

        model.canPatternRelink = function (pattern) {
            return (pattern.StatusId === 2 || pattern.StatusId === 3);
        };

        model.setPattern = function (pattern) {
            if (model.canPatternRelink(pattern)) {
                model.relinkPatternId = pattern.PatternId;
            }
        }

        model.getSeasonsForShift = function () {
            model.shiftSeasons = [];
            PrototypeService.getSeasonsForPrototypeShift(model.prototypeSeasonalDetails.PrototypeSeasonalId).then(function (data) {
                angular.forEach(data,
                    function (season) {
                        if (season.SeasonId !== model.prototypeSeasonalDetails.SeasonId)
                            model.shiftSeasons.push(season);
                    });
            });
        };

        model.loadShiftLinePlan = function () {
            model.shiftLinePlan = null;
            model.shiftLinePlanId = 0;

            LinePlanService.getLinePlanForPatternSeason(model.patternId, model.shiftSeasonId, 0).then(function (data) {
                model.shiftLinePlan = data;
                if (data)
                    model.shiftLinePlanId = data.LinePlanId;
            });
        };

        model.startShift = function () {
            model.shiftLinePlan = null;
            model.shiftSeasonId = 0;
            model.shiftLinePlanId = 0;

            model.getSeasonsForShift(model.prototypeSeasonalDetails.BrandId);
        };

        model.shiftSeason = function () {
            CarryoverService.shiftPrototypeSeason(model.prototypeSeasonalId, model.shiftLinePlanId)
                .then(
                    function (response) {
                        if (response.Result !== 0) {
                            toaster.pop({ type: "error", title: "Error!", body: response.Message, timeout: 5000 });
                            return;
                        }

                        getPrototypeSeasonalDetails();

                        $("#shiftModal").modal("hide");

                        if (response.Data > 1) {
                            toaster.pop({ type: "success", title: "Success!", body: "Season changed successfully on " + response.Data + " dual sourced Colorway Seasonals.", timeout: 3000 });
                        } else {
                            toaster.pop({ type: "success", title: "Success!", body: "Season changed successfully.", timeout: 3000 });
                        }
                    },
                    function (response) {
                        toaster.pop({ type: "error", title: "Error!", body: response, timeout: 5000 });
                    });
        };

        function getSeasonList() {
            var searchObject = {
                PrototypeId: model.prototypeDetails.PrototypeId,
                PageNumber: 1,
                PageSize: 999
            }
            PrototypeService.searchPrototypes(searchObject).then(function (response) {
                if (response.results.length > 0) {
                    model.prototypeSeasons = response.results;
                }
            },
                function (error, status) {
                    model.prototypeSeasons = null;
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'There was an error while getting Prototype Seasons. Please contact system administrator',
                        timeout: 5000
                    });
                });
        }

        model.closeModal = function () {
            $('#seasonList').modal('hide');
        };

        model.onSizeRangeClose = function (hasChanges, prototypeEditForm) {
            if (hasChanges)
                prototypeEditForm.$setDirty(true);
        };

        $scope.$watchCollection('vm.sizeRanges', function (n, o) {
            model.sizeRanges = n;
        });

        $scope.$watchCollection('vm.sizeRangeText', function (n, o) {
            model.sizeRangeText = n;
        });
    }

})();
